import * as React from 'react';

import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';

import Modal from 'src/components/common/Modal';
import Input from 'src/components/common/Input';

import './EcheckVoidModal.scss';

interface IEcheckVoidModalProps {
  voidEcheck: (databaseId: number, params: any) => void;
  handleCloseModal: () => void;
  paymentId: number;
}

interface IEcheckVoidModalState {
  note: string;
}

class CreditVoidModal extends React.Component<
  IEcheckVoidModalProps,
  IEcheckVoidModalState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      note: ''
    };
  }

  private onChangeNote = (note: string) => {
    if (!note || (note !== ' ' && !startEndWithWhiteSpacesValidation(note))) {
      this.setState({
        note
      });
    }
  };

  private handleVoid = () => {
    const params: any = {
      disposition: 'VT',
      taker: 'VOID',
      note: this.state.note
    };

    this.props.voidEcheck(this.props.paymentId, params);
  };

  public render() {
    return (
      <Modal handleCloseModal={this.props.handleCloseModal}>
        <div className="rp-echeck-void-modal">
          <span
            onClick={e => this.props.handleCloseModal()}
            className="rpds-close rp-echeck-void-modal--close-icon"
          />
          <div className="rp-echeck-void-modal--title">
            Are you sure you want to void this payment?
          </div>
          <div className="rp-echeck-void-modal--text">
            Add a reason under the note input field and click continue to void
            this payment.
          </div>
          <Input
            className={'rp-echeck-void-modal--input'}
            label={'Note:'}
            value={this.state.note}
            onChange={this.onChangeNote}
            required={true}
          />
          <div className="rp-echeck-void-modal--buttons">
            <button
              className="secondary-button"
              onClick={this.props.handleCloseModal}
            >
              Cancel
            </button>
            <button
              className={`primary-button ${this.state.note ? '' : 'disabled'}`}
              onClick={this.handleVoid}
              disabled={!this.state.note}
            >
              Continue
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default CreditVoidModal;
